
import { useState } from 'react';
import { portfolioSpecificData, defaultPaymentMethods, defaultDiscountCodes } from '../portfolioData';
import { calculateBillingTotals, formatCurrency } from '../billingUtils';

export const useBillingState = (portfolioId: string) => {
  // Get portfolio data or use defaults if not found
  const portfolioSpecificEntry = portfolioSpecificData[portfolioId || ''];
  
  // Default billing data structure
  const defaultBillingData = {
    activeBusinesses: [],
    pausedBusinesses: [],
    managedBudgets: [],
    availableCredits: 0,
    promotionalDiscount: 0,
    billingManager: {
      name: '',
      email: '',
      phone: ''
    },
    billingHistory: []
  };
  
  // Set up billing data
  const billingData = portfolioSpecificEntry?.billingData || defaultBillingData;
  
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState("card1");
  
  const { totalCharge } = calculateBillingTotals({ billingData });

  return {
    portfolioData: { billingData },
    paymentMethods: defaultPaymentMethods,
    discountCodes: defaultDiscountCodes,
    totalCharge,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    formatCurrency
  };
};
